import { bucketS3, caminhoAnexosFerramentaVideo } from 'constants/EnvironmentData';
import Colors from 'enums/Colors';
import React, { useRef, useState, useEffect } from 'react';

interface ImagemPreviewFerramentaVideoProps {
    filepath?: string; // Caminho da imagem (caso não haja base64)
    onBase64Change?: (base64: string) => void; // Callback para retornar o base64
    resetForm: () => void; // Função para resetar o formulário
    styles?: React.CSSProperties; // Estilos adicionais
    base64?: string;
    setBase64: (base64: string | null) => void;
}

const ImagemPreviewFerramentaVideo: React.FC<ImagemPreviewFerramentaVideoProps> = ({ filepath, onBase64Change, resetForm, styles, base64, setBase64 }) => {
    const inputRef = useRef<HTMLInputElement>(null);

    const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                const result = reader.result as string;
                setBase64(result);
                if (onBase64Change) onBase64Change(result);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleButtonClick = () => {
        inputRef.current?.click();
    };

    const resetBase64 = () => {
        setBase64?.(null);
        resetForm();
        if (onBase64Change) onBase64Change('');
    };

    const getS3BaseUrlFerramentaVideo = (): string => {
        return bucketS3() + caminhoAnexosFerramentaVideo();
    };

    return (
        <div>
            <input type="file" accept="image/*" style={{ display: 'none' }} ref={inputRef} onChange={handleImageChange} />
            <button
                type="button"
                onClick={handleButtonClick}
                style={{
                    background: '#1976d2',
                    color: '#fff',
                    border: 'none',
                    borderRadius: 6,
                    padding: '10px 24px',
                    fontSize: 16,
                    cursor: 'pointer',
                    fontWeight: 500,
                    boxShadow: '0 2px 8px rgba(25, 118, 210, 0.08)',
                    transition: 'background 0.2s',
                }}
                onMouseOver={e => (e.currentTarget.style.background = '#1565c0')}
                onMouseOut={e => (e.currentTarget.style.background = '#1976d2')}
            >
                Selecionar Imagem
            </button>
            <button
                type="button"
                onClick={resetBase64}
                style={{
                    background: '#d2b019',
                    color: '#fff',
                    border: 'none',
                    borderRadius: 6,
                    padding: '10px 24px',
                    fontSize: 16,
                    cursor: 'pointer',
                    fontWeight: 500,
                    boxShadow: '0 2px 8px rgba(25, 118, 210, 0.08)',
                    transition: 'background 0.2s',
                    marginLeft: 8,
                }}
                onMouseOver={e => (e.currentTarget.style.background = '#d2a719')}
                onMouseOut={e => (e.currentTarget.style.background = '#d2a719')}
            >
                Remover Imagem
            </button>
            <div
                style={{
                    marginTop: 16,
                    border: '2px dashed #aaa',
                    borderRadius: 8,
                    padding: 16,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: 560,
                    minWidth: 471,
                    background: '#fafafa',
                    height: 320,
                    boxSizing: 'border-box',
                    ...styles,
                }}
            >
                {base64 ? (
                    <img
                        src={base64}
                        alt="Preview"
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'fill',
                            borderRadius: 8,
                        }}
                    />
                ) : filepath ? (
                    <img
                        src={getS3BaseUrlFerramentaVideo() + filepath}
                        alt="Preview"
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',

                            borderRadius: 8,
                        }}
                    />
                ) : (
                    <span style={{ color: Colors.Blue }}>Nenhuma imagem selecionada</span>
                )}
            </div>
        </div>
    );
};

export default ImagemPreviewFerramentaVideo;
